export const SESSION_STATUS_SCHEDULED = 0
export const SESSION_STATUS_OVERDUE = 1
export const SESSION_STATUS_COMPLETED = 2
export const SESSION_STATUS_INCOMPLETE = 3
export const SESSION_STATUS_IN_PROGRESS = 4
export const SESSION_STATUS_NO_SESSIONS = 5
export const SESSION_STATUS_DUE_TODAY = 6
